import { default as axios } from './http';


class TarpJoinsAPI {

  getTarpJoins = async () => {
    // Fetch tarps from API
    console.log('Fetching tarp joins from API...')
    const url = '/api/v1/gcm/tarp-joins/';
    const response = await axios.get(url)
    return response
  }

  createTarpJoin = async (data) => {
    // Create tarping works in API
    const url = '/api/v1/gcm/tarp-joins/';
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      }
    }
    const response = await axios.post(url, data, options)
    return response
  }

}

export default TarpJoinsAPI;